module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("cDz9R"))).then(() => parcelRequire('lFMrY'));